import Link from 'next/link'

const Footer = () => {
  const menusFooter = [
    { id: '1', label: 'Home', link: '/', target: '_self' },
    { id: '2', label: 'Pricing', link: '/pricing', target: '_self' },
    {
      id: '3',
      label: 'Help',
      link: 'https://discord.com/invite/aNJQPKRm',
      target: '_blank',
    },
    { id: '4', label: 'Privacy Policy', link: '/privacy', target: '_self' },
    { id: '5', label: 'Terms Of Service', link: '/terms-and-conditions', target: '_self' },
  ]

  return (
    <footer className="border-t border-gray-200 dark:border-gray-800 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <nav>
            <ul className="flex flex-wrap gap-x-6 gap-y-2">
              {menusFooter.map((item) => (
                <li key={item.id}>
                  <Link
                    href={item.link}
                    target={item.target}
                    rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                    className="text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="text-sm text-gray-500 dark:text-gray-400">
            © {new Date().getFullYear()} Styley, Inc. All rights reserved.
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-xs text-gray-400 dark:text-gray-500">Built with ❤️ by the Styley Team</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
